import { GET_WITH_CREDENTIALS } from '~/api';
import { JiraCreateMetaApiUrl } from '~/api/urls';
import { IJiraCreateMeta } from '~/domain/IJiraCreateMeta';

/**
 * @returns create meta for all issue types for the review project
 */
export const getIssueCreateMeta = async (): Promise<IJiraCreateMeta> => {
  const url = JiraCreateMetaApiUrl.expand({});
  const meta = await GET_WITH_CREDENTIALS<IJiraCreateMeta>(url);
  if (!meta) {
    throw new Error('Could not create meta (undefined)');
  }
  return meta;
}
